import React, { PureComponent } from 'react';
import styles from './ReviewRequests.module.css';
import PropTypes from 'prop-types';
import moment from 'moment';
import Select from 'react-select';
import Divider from '../Divider';

export default class ReviewRequests extends PureComponent {
  state = {};

  static contextTypes = {
    router: PropTypes.object,
  };

  componentDidMount() {}

  renderReviewRequest(request) {
    const { navTo } = this.props;
    return (
      <div
        key={request._id}
        className={styles.requestContainer}
        onClick={e => navTo(request._id, 'requests')}
      >
        <div className={styles.requestTitle}> {request.title} </div>
        <div className={styles.requestSubTitle}>
          {`opened by ${request.creator} at ${moment(
            request.createdAt
          ).fromNow()}`}
        </div>
      </div>
    );
  }

  render() {
    const { requests } = this.props;
    return (
      <div className={styles.container}>
        <div className={styles.catContainer}>
          <div className={styles.catHeader}>Review Requests</div>
          <Divider />
        </div>
        <div className={styles.requestsHeader}>
          <div className={styles.statics}>{requests.length} Open</div>
          <div className={styles.filter}>
            <Select className={styles.select} placeholder="Tag" />
            <Select className={styles.select} placeholder="Reviewer" />
          </div>
        </div>
        {Object.keys(requests).map(item =>
          this.renderReviewRequest(requests[item])
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ReviewRequests/index.js